import { render, staticRenderFns } from "./TypeComponent.vue?vue&type=template&id=55346390&"
import script from "./TypeComponent.vue?vue&type=script&lang=js&"
export * from "./TypeComponent.vue?vue&type=script&lang=js&"
import style0 from "./TypeComponent.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports